import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import {
    IControlMeasure,
    IControlMeasureFailureMode,
    IControlType, ICriticalHazards, IFailureModeAssessment, IHarm,
    IProjectFailureMode,
    ISeverity
} from "../types/types";
import {get, post} from "../fetchers/fetchers";
 
import {useParams} from "react-router";
import {Table, TableCell, TableHead, TableRow, Typography} from "@material-ui/core";
import Likelihood from "./likelihood";

interface ILikelihoodsProps {
}

interface IRouteParams {
    id: string
}



const Likelihoods: FC<ILikelihoodsProps> = () => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    const [isLoaded, setIsLoaded] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [severities, setSeverities] = useState<ISeverity[]>([]);
    const [failureModeAssessments, setFailureModeAssessments]= useState<IFailureModeAssessment[]>([]);
    const [reloadHarm, setReloadHarm] = useState<boolean>(false);
    const [riskAssessments, setRiskAssessments] = useState<ICriticalHazards[]>([]);

    useEffect(() => {

        if (tasks.loaded) {

            setFailureModes(tasks.failureModes)
            setFailureModeAssessments(tasks.failureModeAssessments)
            setRiskAssessments(tasks.criticalHazards)
            setSeverities(tasks.severity)

        }

    })

    const params = useParams<IRouteParams>()

    const getFailureModes = async () => {
        // const d = await get<IProjectFailureMode[]>( API_URL + "failure_modes/" + params.id.toString());
        // setFailureModes(d)
    }
    const getSeverities = async () => {
        // const d = await get<ISeverity[]>( API_URL + "severity/");
        // setSeverities(d)
    }

    const getCriticalAssessments = async () => {
        // const assessments = await get<ICriticalHazards[]>( API_URL + "critical_hazards/" + params.id +"/");
        // setRiskAssessments(assessments)
    }
    const getFailureModeAssessments = async () => {
        // const assessments = await get<IFailureModeAssessment[]>( API_URL + "failure_modes/" + params.id +"/assessment");
        // setFailureModeAssessments(assessments)
    }

    useEffect(() => {
        // if (!isLoaded && !isLoading) {
        //     setIsLoading(true)
        //     getFailureModes().then(
        //         () => {
        //             getSeverities().then(
        //                 () => {
        //                     getCriticalAssessments().then(
        //                         () => {
        //                             getFailureModeAssessments().then(
        //                                 () => {
        //                                     setIsLoaded(true)
        //                                     setIsLoading(false)
        //                                 })
        //                         })
        //                 })
        //         })
        // }

        if (reloadHarm) {
            getCriticalAssessments().then(
                () => {
                    setReloadHarm(false)
                })
        }
    }, [isLoaded, isLoading, setIsLoaded, setReloadHarm, reloadHarm])


    return (
        <>
            <Table>
                <TableHead>
                    <TableCell></TableCell>
                    <TableCell>Failure Mode</TableCell>
                    <TableCell>Annual Probability</TableCell>
                    <TableCell>Rating</TableCell>
                </TableHead>
                {
                    isLoaded && failureModes.map((f) => {
                        if (f.failure_mode?.is_active === false) { return <></> }
                        let fma = failureModeAssessments.find(fma => fma.project_failure_mode_id === f.id)
                        if (!fma) {return <></>}
                        if (fma.consider) {
                            return (
                                <Likelihood severities={severities}
                                      failure_mode={f}
                                      critical_hazard={riskAssessments.find(h => fma?.project_failure_mode_id === h.project_failure_mode_id)}/>
                            )
                        }else {
                            return <></>
                        }
                    })
                }

            </Table>
            <div>
                <Typography><small>Note only included group failure modes are shown</small></Typography>
            </div>
        </>

    )

}

export default Likelihoods